
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ofArray, tryFind, filter, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultArg, bind, unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Select } from "../../Components/Select.js";
import { Msg } from "./Types.js";
import { LocationId__get_unwrap, FormState__getValidation } from "../../Shared/Shared.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { LocationAddress_get_empty, tryFindLocationCountry, Hierarchy_getPossibleParents, Hierarchy_isInBusinessUnit, Hierarchy_buildTreeOrderedList } from "../../Shared/Location.js";
import { useCountryOptions } from "../../Components/Countries.js";
import { FormContainer } from "../../Components/FormContainer.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { Input } from "../../Components/Input.js";
import { BlockHeader } from "../../Components/Text.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEditLocationView, update as update_1, initNewLocationView } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapLocationId } from "../../Shared/Helper.js";

function BusinessUnitSelect(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const mapBusinessUnit = (businessUnit) => ({
        label: businessUnit.Name,
        value: businessUnit,
    });
    const options = map(mapBusinessUnit, filter((businessUnit_1) => {
        const matchValue = props.Location.BusinessUnitId;
        if (matchValue == null) {
            return true;
        }
        else {
            return businessUnit_1.Id !== matchValue;
        }
    }, props.BusinessUnits));
    let selectedBusinessUnit;
    const matchValue_1 = props.Location.BusinessUnitId;
    if (matchValue_1 == null) {
        selectedBusinessUnit = undefined;
    }
    else {
        const businessUnitId_1 = matchValue_1;
        selectedBusinessUnit = map_1(mapBusinessUnit, tryFind((businessUnit_2) => (businessUnit_2.Id === businessUnitId_1), props.BusinessUnits));
    }
    return createElement(Select, {
        ComponentState: componentState,
        IsClearable: true,
        Label: t("business_units.business_unit"),
        NoOptionsMessage: "business_units.select.no_options",
        OnChange: (arg) => {
            props.Dispatch(new Msg(7, [arg]));
        },
        Options: options,
        PlaceholderKey: "business_units.select.placeholder",
        TestId: "location-business-unit-select",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "business_unit")),
        Value: unwrap(selectedBusinessUnit),
    });
}

function ParentLocationSelect(props) {
    let Label, Value;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const options = map((tupledArg) => {
        const location_1 = tupledArg[0];
        return {
            label: concat(Array((tupledArg[1] * 4) + 1).join(" "), ...location_1.Name),
            value: location_1,
        };
    }, Hierarchy_buildTreeOrderedList(filter((location) => Hierarchy_isInBusinessUnit(props.Location.BusinessUnitId, location), Hierarchy_getPossibleParents(props.Locations, props.LocationId))));
    return createElement(Select, (Label = t("location.parent_location"), (Value = bind((parentLocationId) => tryFind((option) => (LocationId__get_unwrap(option.value.Id) === parentLocationId), options), props.Location.ParentLocationId), {
        ComponentState: componentState,
        IsClearable: true,
        Label: unwrap(Label),
        NoOptionsMessage: "location.parent_location_no_options",
        OnChange: (arg) => {
            props.Dispatch(new Msg(8, [arg]));
        },
        Options: options,
        PlaceholderKey: "location.parent_location_placeholder",
        TestId: "location-form-parent-select",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "parentLocationId")),
        Value: unwrap(Value),
    })));
}

function CountrySelect(props) {
    let Label, Value;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const patternInput_1 = useCountryOptions();
    return createElement(Select, (Label = t("location.address.country"), (Value = map_1(patternInput_1[1], bind(tryFindLocationCountry, props.Country)), {
        ComponentState: componentState,
        IsClearable: true,
        Label: unwrap(Label),
        NoOptionsMessage: "",
        OnChange: (arg) => {
            props.Dispatch(new Msg(6, [arg]));
        },
        Options: patternInput_1[0],
        PlaceholderKey: "location.address.country_placeholder",
        TestId: "location-form-country-select",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "country")),
        Value: unwrap(Value),
    })));
}

export function LocationForm(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const address = defaultArg(props.Location.Address, LocationAddress_get_empty());
    return createElement(FormContainer, {
        Children: toList(delay(() => {
            let matchValue;
            return append((matchValue = FormState__getValidation(props.FormState, t, "global"), (matchValue == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                Label: matchValue,
            }))), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("general.name"),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(0, [arg]));
                },
                TestId: "location-form-name",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
                Value: props.Location.Name,
            })), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("general.description"),
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(1, [arg_1]));
                },
                TestId: "location-form-description",
                Value: props.Location.Description,
            })), delay(() => append(singleton(createElement(ParentLocationSelect, {
                Dispatch: props.Dispatch,
                FormState: props.FormState,
                Location: props.Location,
                LocationId: unwrap(props.LocationId),
                Locations: props.Locations,
            })), delay(() => append(singleton(createElement(BlockHeader, {
                Text: "location.address.title",
            })), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("location.address.street"),
                OnChange: (arg_2) => {
                    props.Dispatch(new Msg(2, [arg_2]));
                },
                TestId: "location-form-street",
                Value: defaultArg(address.Street, ""),
            })), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("location.address.address_supplement"),
                OnChange: (arg_3) => {
                    props.Dispatch(new Msg(3, [arg_3]));
                },
                TestId: "location-form-address-supplement",
                Value: defaultArg(address.AddressSupplement, ""),
            })), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("location.address.zip_code"),
                OnChange: (arg_4) => {
                    props.Dispatch(new Msg(4, [arg_4]));
                },
                TestId: "location-form-zip-code",
                Value: defaultArg(address.ZipCode, ""),
            })), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("location.address.city"),
                OnChange: (arg_5) => {
                    props.Dispatch(new Msg(5, [arg_5]));
                },
                TestId: "location-form-city",
                Value: defaultArg(address.City, ""),
            })), delay(() => append(singleton(createElement(CountrySelect, {
                Country: unwrap(address.Country),
                Dispatch: props.Dispatch,
                FormState: props.FormState,
            })), delay(() => (isFeatureEnabled(new Feature(17, [])) ? ((props.AccountSettings.BusinessUnitsEnabled && !props.IsEdit) ? singleton(createElement(BusinessUnitSelect, {
                BusinessUnits: props.BusinessUnits,
                Dispatch: props.Dispatch,
                FormState: props.FormState,
                Location: props.Location,
            })) : empty()) : empty())))))))))))))))))))));
        })),
        FormState: props.FormState,
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewLocationView() {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNewLocationView, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.AccountSettings;
    const matchValue_2 = state_1.BusinessUnits;
    const matchValue_3 = state_1.Locations;
    let matchResult, accountSettings, businessUnits, location, locations;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            if (matchValue_2.tag === 1) {
                if (matchValue_3.tag === 1) {
                    matchResult = 1;
                    accountSettings = matchValue_1.fields[0];
                    businessUnits = matchValue_2.fields[0];
                    location = matchValue.fields[0];
                    locations = matchValue_3.fields[0];
                }
                else {
                    matchResult = 0;
                }
            }
            else {
                matchResult = 0;
            }
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return createElement(Skeleton, {
                Variant: "detail",
            });
        default:
            return createElement(LocationForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("location.create_new_location"),
                IsEdit: false,
                Location: location,
                Locations: locations,
                OnBack: () => {
                    RouterModule_nav(ofArray(["locations"]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(9, []));
                },
            });
    }
}

export function EditLocationView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEditLocationView, update_1, (_arg, _arg_1) => {
    }), props.LocationId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.AccountSettings;
    const matchValue_2 = state_1.BusinessUnits;
    const matchValue_3 = state_1.Locations;
    let matchResult, accountSettings, businessUnits, location, locations;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            if (matchValue_2.tag === 1) {
                if (matchValue_3.tag === 1) {
                    matchResult = 1;
                    accountSettings = matchValue_1.fields[0];
                    businessUnits = matchValue_2.fields[0];
                    location = matchValue.fields[0];
                    locations = matchValue_3.fields[0];
                }
                else {
                    matchResult = 0;
                }
            }
            else {
                matchResult = 0;
            }
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return createElement(Skeleton, {
                Variant: "detail",
            });
        default:
            return createElement(LocationForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("location.create_new_location"),
                IsEdit: true,
                Location: location,
                LocationId: props.LocationId,
                Locations: locations,
                OnBack: () => {
                    RouterModule_nav(ofArray(["locations", unwrapLocationId(props.LocationId)]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(10, []));
                },
            });
    }
}

